import { FacebookLogo, GoogleLogo, LinkedInLogo } from '../../icons'

export const SsoIcon = {
  google: <GoogleLogo />,
  facebook: <FacebookLogo />,
  linkedin: <LinkedInLogo />,
}
